module.exports = __webpack_public_path__ + "static/media/open-enrollment-mob.29a3db45.png";